import {UserTracker} from "../index.js";

const eventDics = {
    "search": "main:search:view", // 검색
    "main": "main:project:view", // 메인화면
    "project": "main:project:view", // 프로젝트 화면
    "miniProject": "main:mini-project:view", // 미니 프로젝트
    "nokeep": "main:nokeep:view", // 미분류
    "unread": "main:unread:view", // 미확인
    "star": "main:star:view", // 즐겨찾기
    "gantt": "main:gantt:view", // 간트차트
    "task": "main:task:view", // 업무모아보기
    "schd": "main:schd:view", // 캘린더
    "file": "main:file:view", // 파일함
    "fileChange": "main:file-change:view", // ?
    "history": "main:history:view", // ?
    "dash": "main:dashboard:view", // 대시보드?
    "insight": "main:insight:view", // 인사이트
    "bookmark": "main:bookmark:view", // 북마크
    "mention": "main:mention:view", // 나를 언급
    "mypost": "main:my-post:view", // 내 게시물
    "tmpPost": "main:tmp-post:view", // 임시저장
    "open": "main:open:view", // 회사 공개 프로젝트
    "offc": "main:offc:view", // ?
    "label": "main:label:view", // ?
    "hidden": "main:hidden:view", // 숨김 프로젝트
    "detail": "main:detail:view", // 프로젝트 디테일 화면
    "upgrade": "main:upgrade:view", // 업그레이드 화면
    "payment": "main:payment:view", // 결제 화면
    "portalApp": "main:portal-app:view", // 포탈 화면?
    "stripePayment": "main:stripe-payment:view", // 스트라이프 화면
    "dashboard": "main:dashboard:view", // 대시보드
    "calendar": "main:calendar:view", // 임직원캘린더
    "routine": "main:routine:view", // 루틴
    "report": "main:report:view", // 보고서
}

export const ViewerTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: null, data: {}});
    }

    return Tracker;
}

